import { InputRef } from "antd";
import React, { useRef, MutableRefObject } from "react";
import "../css/components.css";
import { Input as AntInput } from "antd";

import { usePlacesWidget } from "react-google-autocomplete";
import _ from "lodash";

interface PlacesLocation {
  getLocationLatLngAndAddress: Function;
  locationAddress: string;
  onLocationTextChange: Function;
  setLatLng: Function;
  hasError: boolean;
}

export const PlacesLocation = (props: PlacesLocation) => {
  const {
    getLocationLatLngAndAddress,
    locationAddress,
    onLocationTextChange,
    hasError,
    setLatLng,
  } = props;
  // console.log("new address", ListofAddress);
  // const [cities, setCities] = useState([]);
  let antInputRef = useRef<InputRef | null>(null);

  const { ref: antRef } = usePlacesWidget({
    // apiKey: `AIzaSyAuGQv4L0nbZsPreBugtxX0lyKm2zC4Cno`,
    apiKey: "AIzaSyAnAXwnT1GTlRVUnEeApK09pTByQD4mdXU",
    inputAutocompleteValue: "off",

    options: {
      types: ["(cities)"],
    },
    onPlaceSelected: (place) => {
      //   @ts-ignore
      getLocationLatLngAndAddress(
        {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        },
        place.formatted_address
      );
      if (place?.address_components) {
        const country = _.last(place.address_components);
        const city = _.first(place.address_components);
        const lat = place.geometry.location.lat();
        const long = place.geometry.location.lng();
      }
    },
  });
  return (
    <div className="address-box-outer-div">
      <div className="c-c-ddm" style={{ width: "100%" }}>
        <AntInput
          autoComplete="off"
          name={`location`}
          type="text"
          value={locationAddress}
          onChange={(val) => {
            setLatLng({ lat: 0, lng: 0 });
            onLocationTextChange(val);
          }}
          style={{ width: "100%" }}
          status={hasError ? "error" : ""}
          placeholder="Enter your location"
          className="pac-container"
          ref={(element) => {
            (antInputRef as MutableRefObject<InputRef | null>).current = element;

            antInputRef.current = element;
            // console.log("verify", c);
            if (element)
              (antRef as MutableRefObject<HTMLInputElement | null>).current = element.input;
            // if (element)  antRef.current = element.input as any;
          }}
        />
      </div>
    </div>
  );
};

export default PlacesLocation;
